import { CompanyDto } from './company-dto.model';
import { ShiftDayDto } from './shift-day-dto.model';


export class ShiftGroupDto implements IShiftGroupDto {
    id!: number | undefined;
    company!: CompanyDto;
    shiftGroupName!: string | undefined;
    isActive!: boolean;
    shiftDay!: ShiftDayDto[] | undefined;

    constructor(data?: IShiftGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.shiftGroupName = _data["shiftGroupName"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["shiftDay"])) {
                this.shiftDay = [] as any;
                for (let item of _data["shiftDay"])
                    this.shiftDay!.push(ShiftDayDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["shiftGroupName"] = this.shiftGroupName;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.shiftDay)) {
            data["shiftDay"] = [];
            for (let item of this.shiftDay)
                data["shiftDay"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IShiftGroupDto {
    id: number | undefined;
    company: CompanyDto;
    shiftGroupName: string | undefined;
    isActive: boolean;
    shiftDay: ShiftDayDto[] | undefined;
}

